import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const ThumbIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 48.523 45.396">
      <g id="Group_395" data-name="Group 395" transform="translate(-31 -91)">
        <g id="Group_396" data-name="Group 396" transform="translate(31 91)">
          <g id="Group_395-2" data-name="Group 395" transform="translate(0 0)">
            <path
              id="Path_206"
              data-name="Path 206"
              d="M78.284,115.37a4.85,4.85,0,0,0-3.613-8.087H65.253a31.362,31.362,0,0,0,1.331-8.2V97.47A6.478,6.478,0,0,0,60.114,91H58.5a1.617,1.617,0,0,0-1.569,1.225l-.881,3.525c-1.235,4.936-5.154,10.383-9.211,11.373a4.859,4.859,0,0,0-4.514-3.075h-9.7A1.618,1.618,0,0,0,31,105.665v29.114a1.618,1.618,0,0,0,1.617,1.617h9.7a4.857,4.857,0,0,0,4.38-2.766l5.558,1.853a17.753,17.753,0,0,0,5.627.913h13.55a4.854,4.854,0,0,0,4.512-6.64,4.85,4.85,0,0,0,2.337-7.917,4.843,4.843,0,0,0,0-6.47ZM43.94,131.544a1.619,1.619,0,0,1-1.617,1.617H34.235V107.282h8.087A1.619,1.619,0,0,1,43.94,108.9Zm27.5-14.557h3.235a1.617,1.617,0,0,1,0,3.235H71.436a1.617,1.617,0,0,0,0,3.235h3.235a1.617,1.617,0,0,1,0,3.235H71.436a1.617,1.617,0,1,0,0,3.235,1.617,1.617,0,1,1,0,3.235H57.886a14.525,14.525,0,0,1-4.6-.747l-6.107-2.036V110.364a13.034,13.034,0,0,0,7.262-4.719,23.6,23.6,0,0,0,4.748-9.111l.575-2.3h.355a3.239,3.239,0,0,1,3.235,3.235v1.616a25.594,25.594,0,0,1-1.548,8.2H58.5a1.617,1.617,0,0,0,0,3.235H74.671a1.617,1.617,0,1,1,0,3.235H71.436a1.617,1.617,0,0,0,0,3.235Z"
              transform="translate(-31 -91)"
              fill={props.color || theme.palette.white.main}
            />
          </g>
        </g>
        <g id="Group_398" data-name="Group 398" transform="translate(37.064 126.587)">
          <g id="Group_397" data-name="Group 397" transform="translate(0 0)">
            <circle
              id="Ellipse_72"
              data-name="Ellipse 72"
              cx="1.5"
              cy="1.5"
              r="1.5"
              transform="translate(-0.064 0.341)"
              fill={props.color || theme.palette.white.main}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
